import { render, staticRenderFns } from "./NuevaVacunacion.vue?vue&type=template&id=4dfad35a&scoped=true"
import script from "./NuevaVacunacion.vue?vue&type=script&lang=js"
export * from "./NuevaVacunacion.vue?vue&type=script&lang=js"
import style0 from "./NuevaVacunacion.vue?vue&type=style&index=0&id=4dfad35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfad35a",
  null
  
)

export default component.exports